const Cart = require('app/components/checkout/Cart')
const BasketStep = require('app/components/checkout/steps/ProductBasket')
const RecipientStep = require('app/components/checkout/steps/Recipient')
const ClientStep = require('app/components/checkout/steps/Client')
const OverviewStep = require('app/components/checkout/steps/Overview')
const PaymentTypeStep = require('app/components/checkout/steps/PaymentType').default
const env = require('app/services/env')
const checkout = require('app/pipelines/checkout/products')
const axios = require('axios')
const router = require('app/services/router')
const Trans = require('app/components/trans/Trans')

class ProductCart extends Cart {
  get baseClassName () {
    return super.baseClassName + ' product-checkout'
  }

  setWarning (input) {
    this.setState({ skipWarning: input })
  }

  get warningStatus () {
    return this.state.skipWarning
  }

  get startIndex () {
    return 1
  }

  get cart () {
    return env.get('checkout.cart.products')
  }

  get pipelines () {
    return checkout
  }

  get steps () {
    // Payment cart (only show overview)
    if (this.cart.status === 'expecting_payment') {
      axios.post(router.route('api.checkout.products.unlock'), { cart_id: this.cart.guid }).then(response => {
      })
      return [
        {
          component: PaymentTypeStep,
          props: {
            prevAction: translate('Tilbage') ,
            nextAction: translate('Gå til sikker betaling')
          }
        }
      ]
      return [
        {
          component: OverviewStep,
          props: {
            prevAction: translate('Rediger ordre'),
            nextAction: translate('Betal')
          }
        }
      ]
    }

    return [
      {
        component: BasketStep,
        props: {
          prevAction: translate('Tøm kurven'),
          nextAction: translate('Gå til levering')
        }
      },
      {
        component: RecipientStep,
        props: {
          prevAction: translate('Tilbage til kassen') ,
          setWarning: (input) => this.setWarning(input)
        }
      },
      {
        component: ClientStep,
        props: {
          prevAction: translate('Tilbage til levering')
        }
      },
      {
        component: OverviewStep,
        props: {
          prevAction: translate('Ret oplysninger') ,
          nextAction: translate('Gå til betaling'),
          getWarning: this.state.skipWarning
        }
      },
      {
        component: PaymentTypeStep,
        props: {
          prevAction: translate('Tilbage'),
          nextAction: translate('Gå til sikker betaling')
        }
      }
    ]
  }
}

module.exports = ProductCart
